export const buildDate: string = "2026-04-22 14:52:00";
export const appState:number = 1;
